import type { AgentRun } from '@lucidtech/las-sdk-browser';
import { AccessorKeyColumnDef } from '@tanstack/react-table';
import { memo, useMemo } from 'react';

import { AgentRunDocumentCard, AgentRunStatus } from '@/components/ui';

import { AgentRunsTable } from '../inbox/AgentRunsTable.tsx';
import { Panel } from './Panel.tsx';

export type DetailsAgentRunsPanelProps = {
  agentId?: string;
};

const IDetailsAgentRunsPanel = ({ agentId }: DetailsAgentRunsPanelProps) => {
  const columns = useMemo<AccessorKeyColumnDef<AgentRun>[]>(() => {
    return [
      {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ row }) => <AgentRunStatus agentId={row.original.agentId} runId={row.original.runId} compact />,
        enableSorting: false,
      },
      {
        accessorKey: 'file',
        header: 'File',
        cell: ({ row }) => (
          <AgentRunDocumentCard className="mx-2" agentId={row.original.agentId} runId={row.original.runId} />
        ),
        size: Number.MAX_SAFE_INTEGER,
        enableSorting: false,
      },
      {
        accessorKey: 'createdTime',
        cell: () => null,
        size: 0,
      },
      {
        accessorKey: 'updatedTime',
        cell: () => null,
        size: 0,
      },
    ];
  }, []);

  const props = useMemo(() => {
    return {
      outerContainer: { className: 'border-none' },
      row: { className: 'border-none overflow-hidden' },
    };
  }, []);

  return (
    <Panel>
      <AgentRunsTable
        className="p-1"
        agentId={agentId}
        columns={columns}
        hideHeaders
        hideSelectionColumn
        props={props}
      />
    </Panel>
  );
};

export const DetailsAgentRunsPanel = memo(IDetailsAgentRunsPanel) as typeof IDetailsAgentRunsPanel;
